import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CaseTaxDto, UniqueDataDto, UpdateCaseUniqueDataCommand, TaxType } from '@vpfa/rest-api/valuation';
import { ValuationUniqueDataFromName } from '../unique-data-valuation/unique-data-valuation.component';
import { cloneDeep } from 'lodash';
import { UniqDataValuationOptions } from '../../models/uniq-data-valuation-options';
import { BranchListItemDto } from '@vpfa/rest-api/admin';
import { SelectOption } from '@vpfa/ui-kit';
import { convertValuationFormDataToUpdateCommand } from '../unique-data-valuation/convert-form-data';
import { UniqueDataModel } from '../../models/unique-data.model';

@Component({
  selector: 'vpfa-unique-data-valuation-modal',
  templateUrl: './unique-data-valuation-modal.component.html',
  styleUrls: ['./unique-data-valuation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValuationUniqueDataModalComponent {
  @Input() set initialData(initialData: Partial<UniqueDataDto>) {
    if (!initialData) return;
    this._initialData = initialData;
  }

  get initialData() {
    return this._initialData;
  }

  @Input() dataValuationOptions: UniqDataValuationOptions;
  @Input() open = false;
  @Input() loading = false;
  @Input() set taxes(taxes: CaseTaxDto) {
    this._taxes = taxes;
  }
  @Input() branchList: BranchListItemDto[];
  @Input() hideInteriorTrimColour = false;
  @Input() hideBuildDate = false;
  @Input() buildDateNotAvailable = false;
  @Input() isCaseIdentifiedByVin = false;

  @Output() closeModal = new EventEmitter();
  @Output() save: EventEmitter<UniqueDataModel> = new EventEmitter();

  isBranchIdModified: boolean | null = null;

  get taxes(): CaseTaxDto {
    return this._taxes;
  }

  formGroup = new UntypedFormGroup({});

  private _initialData: Partial<UniqueDataDto>;
  private _taxes: CaseTaxDto;

  onClose() {
    this.resetData();
    this.closeModal.emit();
  }

  onSubmit() {
    const formValue = this.formGroup.getRawValue();
    const valuationDataSection = convertValuationFormDataToUpdateCommand(formValue[ValuationUniqueDataFromName]);
    const taxOption: SelectOption<TaxType> = formValue.taxType;

    this.save.emit({
      uniqueData: { valuationDataSection, taxType: taxOption.value },
      hasBranchBeenUpdated: this.isBranchIdModified,
    });
  }

  private resetData() {
    this._initialData = cloneDeep(this._initialData);
    this._taxes = cloneDeep(this._taxes);
  }
}
